import { Button, Card, CardBody, CardFooter, CardTitle, Flex, FlexItem, StackItem } from "@patternfly/react-core";
import type React from "react";
import Code from "../../../../assets/code.svg";
import WebsiteImage from "../../../../assets/webiste.png";
import "./CertifySoftwareCard.scss";
import { LEARN_CERT, LEARN_VALIDATION } from "../../../../constants/DashBoardUrls";
import Env from "../../../../utils/env";

const CertifySoftwareCard: React.FC = () => {
	const title = "Validate or certify your products with Red Hat";
	return (
		<StackItem>
			<Card data-analytics-category={title} className="certify-card">
				<Flex alignItems={{ default: "alignItemsCenter" }} flexWrap={{ default: "nowrap" }}>
					<FlexItem>
						<img className="certify-card__img" src={WebsiteImage} alt="website-image" aria-hidden={true} />
					</FlexItem>
					<FlexItem>
						<Flex alignItems={{ default: "alignItemsCenter" }} gap={{ default: "gapXs" }}>
							<FlexItem>
								<CardTitle className="certify-card__title" component="h2">
									{title}
								</CardTitle>
							</FlexItem>
							<FlexItem>
								<img className="certify-card__title-icon" src={Code} alt="code-icon" aria-hidden={true} />
							</FlexItem>
						</Flex>
						<CardBody>
							Validate or certify your product on Red Hat platforms, to publish and promote it on the Red Hat Ecosystem
							Catalog.
						</CardBody>
						<CardFooter>
							<Flex>
								<FlexItem>
									<Button
										component="a"
										href={`${Env.ConnectPortalUrls[Env.getEnvName()]}manage/products`}
										variant="primary"
									>
										Create a product
									</Button>
								</FlexItem>
								<FlexItem>
									<Button component="a" target="_blank" href={LEARN_CERT} variant="secondary">
										Learn about certification
									</Button>
								</FlexItem>
								<FlexItem>
									<Button component="a" target="_blank" href={LEARN_VALIDATION} variant="secondary">
										Learn about validation
									</Button>
								</FlexItem>
							</Flex>
						</CardFooter>
					</FlexItem>
				</Flex>
			</Card>
		</StackItem>
	);
};

export default CertifySoftwareCard;
